const initialState = null;

const newCarsData = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_NEW_CARS_DATA_SUCCESS':
			return Object.assign([],state, {...action.payload} );
		case 'GET_NEW_CARS_DATA_FAILURE':
			return Object.assign([],state, []);
		default:
			return state;
	}
};

export default newCarsData;


// WEBPACK FOOTER //
// ../q-cars/src/redux/reducers/newcars.js